<template>
  <Form 
    :d_form='form1'
    :d_se_katalog='se_katalog'
    :d_negeri='negeri'
    v-if="id > 0 && load == 3"
  /> 
  <Form 
    :d_form='form'
    :d_se_katalog='se_katalog'
    :d_negeri='negeri'
    v-else-if="id == 0 && load == 2"
  /> 
</template>

<script>
import { reactive } from 'vue'
import ZResource from '@/Modules/z-resource'
import Form from "./_From.vue";

export default {
  extends: ZResource,
  components: {
    Form
  },
  props: {
    id: [Array, Object],
  },
  data() {
    return {
      resourceurl: 'se.pemungutan',
      crumbs: [
        { label: this.$page.props.app_name, route: '/home' },
        { label: 'Pengurusan Semen Beku', route: '/se' },
        { label: 'Pemungutan Semen Ternakan', route: '/se/pemungutan' },
      ],
      title : 'Tambah Baka Jantan',
      form : {
        id : 0,
        tarikh : 0,
        se_katalog_id : '',
        masa: '',
        jumlah_penjatan_palsu : '',
        bil_pungutan : '',
        no_ejekulasi : '',
        lkp_ejekulasi_id : '',
        tujahan : '',
        libido : '',
        isipadu : '',
        warna : '',
        skor_ketumpatan : '',
        catatan : '',
        user_id : '',
        nama: '',
        hantar:2
      },
      form1:[],
      se_katalog : [],
      negeri: [],
      load : 0
      
      
    }
  },
  methods: {
    
    getKatalog(){
      this.$zcomm.get(this.api_service + 'lookup/se_katalog', {}).then(res => {
        this.se_katalog = res
        this.load = this.load + 1
      })
    },

    getNegeri(){
      this.$zcomm.get(this.api_service + 'lookup/negeri/1', {}).then(res => {
         this.negeri = res
         this.load = this.load + 1
      })
    },
 
    getData(){
      if(this.id > 0){
        this.$zcomm.get(this.api_service + 'se_pemungutan/show/'+this.id, {}).then(res => {
          this.form1 = res
          this.load = this.load + 1

        })
      }
    },
  
  },

  watch: {

  },
  mounted() {
    this.getData();
    this.getNegeri()
    this.getKatalog()
    
  }
    
}
</script>
